/* BYON · Compra rápida (rediseño UX sep-2026, agente Colecciones; R1)
 * - Mantiene el custom element <quick-add-modal> de Dawn (ModalDialog: foco atrapado, Esc y clic afuera cierran).
 * - Ya no descarga la ficha completa: lee /products/<handle>.js (JSON liviano e independiente del template de producto)
 *   y arma una hoja inferior (mobile) o modal (desktop): miniatura, nombre, precio, sabores en pills, cantidad,
 *   botón fijo "Agregar al carro · $X" y link "Ver detalle del producto".
 * - Agrega al carro con <product-form> de Dawn (product-form.js): cierra la hoja y abre el carro lateral.
 *   Si product-form.js no estuviera cargado, el formulario hace POST normal a /cart/add (fallback sin JS).
 * - R1: sabores en 2 columnas (elegido, disponibles y agotados al final; C1-COL-09); cuota truncada como Venti y
 *   "con débito" (C1-COL-01); packs sin tachado ni "−%" (K4, C1-COL-05); evento add_to_cart con la respuesta OK
 *   para la tarjeta (atc_source 'card') y la hoja ('quick_add') en todo el sitio (K1, C1-COL-07).
 * - R2 (R2-GC-01): en packs, "Por separado $X · Ahorras $Y" con los datos que la tarjeta toma de byon-pack-savings.
 * - R11 (D2 · SEO-3 A): en las guías del blog (tarjeta, minitarjeta o hoja abierta desde un [data-byon-guide]) el evento
 *   sale con atc_source 'guide' y guide: <handle del artículo>. Fuera de las guías no cambia nada.
 * - R11 (D2 · K12, pedido de C): la línea de cuotas usa window.byonCart.payText (assets/byon-cart.js). Con Webpay
 *   apagado devuelve null y queda el texto de Venti de ronda 10; '' oculta la línea; otro valor es el texto de Webpay.
 */
(function () {
  if (window.__byonAtcTracking) return;
  window.__byonAtcTracking = true;
  var pending = null;
  var track = function (name, data) {
    (window.byonTrack || function () {})(name, data);
  };
  var guideOf = function (el) {
    var g = el && el.closest ? el.closest('[data-byon-guide]') : null;
    return g ? g.getAttribute('data-byon-guide') || '' : '';
  };
  // Se registra qué formulario del tema envió el agregado (tarjeta u hoja) y se emite con la respuesta OK de Dawn
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      var host = form.closest('product-form');
      if (!host) return;
      if (host.hasAttribute('data-byon-atc')) {
        var g1 = guideOf(host);
        pending = {
          atc_source: g1 ? 'guide' : host.getAttribute('data-byon-atc') || 'card',
          guide: g1,
          item_id: String(host.getAttribute('data-byon-item') || ''),
          variant_id: String(idInput.value),
          item_name: host.getAttribute('data-byon-name') || '',
          price: Number(host.getAttribute('data-byon-price')) || 0,
          quantity: Number((form.querySelector('[name="quantity"]') || {}).value) || 1,
          at: Date.now(),
        };
      } else if (form.closest('[data-byon-qa]')) {
        var qa = form.closest('[data-byon-qa]');
        var modal = form.closest('quick-add-modal');
        var g2 = guideOf(modal && modal.openedBy);
        pending = {
          atc_source: g2 ? 'guide' : 'quick_add',
          guide: g2,
          item_id: String(qa.getAttribute('data-byon-item') || ''),
          variant_id: String(idInput.value),
          item_name: qa.getAttribute('data-byon-name') || '',
          price: Number(qa.getAttribute('data-byon-price')) || 0,
          quantity: Number((form.querySelector('[name="quantity"]') || {}).value) || 1,
          at: Date.now(),
        };
      }
    },
    true
  );
  var hook = function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!pending || !data || data.source !== 'product-form') return;
      if (String(data.productVariantId) !== pending.variant_id || Date.now() - pending.at > 20000) return;
      var p = pending;
      pending = null;
      var ev = {
        atc_source: p.atc_source,
        item_id: p.item_id,
        variant_id: p.variant_id,
        item_name: p.item_name,
        price: p.price,
        quantity: p.quantity,
        currency: 'CLP',
      };
      if (p.guide) ev.guide = p.guide;
      track('add_to_cart', ev);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook);
  else hook();
})();

if (!customElements.get('quick-add-modal')) {
  const BYON_QA_CACHE = new Map();

  const byonEsc = (value) =>
    String(value == null ? '' : value).replace(
      /[&<>"']/g,
      (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
    );

  const byonMoney = (cents) =>
    '$' + String(Math.round((Number(cents) || 0) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Cuota igual que Venti: truncada al peso (centavos → 3 cuotas)
  const byonCuota = (cents) => Math.floor((Number(cents) || 0) / 300) * 100;

  const byonImg = (src, width) => {
    if (!src) return '';
    const url = typeof src === 'string' ? src : src.src || '';
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  };

  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      static getProduct(url) {
        const path = String(url).split('#')[0].split('?')[0].replace(/\/$/, '');
        if (!BYON_QA_CACHE.has(path)) {
          const request = fetch(path + '.js', { headers: { Accept: 'application/json' } })
            .then((response) => {
              if (!response.ok) throw new Error('HTTP ' + response.status);
              return response.json();
            })
            .catch((error) => {
              BYON_QA_CACHE.delete(path);
              throw error;
            });
          BYON_QA_CACHE.set(path, request);
        }
        return BYON_QA_CACHE.get(path);
      }

      show(opener) {
        if (!opener) return;
        const url = opener.getAttribute('data-product-url');
        if (!url) return;
        const spinner = opener.querySelector('.loading-overlay__spinner');
        // K4: la tarjeta avisa si es pack y, si hay datos de componentes, el precio por separado y el ahorro (centavos)
        this.pack = {
          isPack: opener.getAttribute('data-byon-pack') === '1',
          separate: Number(opener.getAttribute('data-byon-pack-separate')) || 0,
          saving: Number(opener.getAttribute('data-byon-pack-saving')) || 0,
          // R4 (8-oct-2026): tachado del pack (suma de los precios sin descuento de sus componentes), el mismo de la tarjeta.
          ref: Number(opener.getAttribute('data-byon-pack-ref')) || 0,
        };
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        QuickAddModal.getProduct(url)
          .then((product) => {
            this.renderProduct(product);
            document.body.classList.add('byon-overlay-open');
            super.show(opener);
          })
          .catch(() => {
            window.location.href = url;
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      hide(preventFocus = false) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        this.qa = null;
        if (preventFocus) this.openedBy = null;
        const otherOpen = Array.from(document.querySelectorAll('quick-add-modal[open]')).some((m) => m !== this);
        if (!otherOpen) document.body.classList.remove('byon-overlay-open');
        super.hide();
      }

      normalizeOptions(product) {
        const variants = product.variants || [];
        return (product.options || []).map((option, index) => {
          const name = typeof option === 'string' ? option : option.name;
          let values = typeof option === 'string' ? null : option.values;
          if (!values || !values.length) {
            values = [];
            variants.forEach((variant) => {
              const value = variant.options[index];
              if (values.indexOf(value) === -1) values.push(value);
            });
          }
          return { name, values };
        });
      }

      renderProduct(product) {
        const variants = product.variants || [];
        const options = this.normalizeOptions(product);
        const hasOptions = !(variants.length === 1 && /^default title$/i.test(variants[0].title || ''));
        const current = variants.find((variant) => variant.available) || variants[0];
        const uid = 'QA' + product.id;
        this.qa = { product, variants, options, uid, selected: current.options.slice(), current, qty: 1 };

        // C1-COL-09: orden de la ficha → el elegido, luego los disponibles y al final los agotados
        const valueAvailable = (i, value) => variants.some((v) => v.available && v.options[i] === value);
        const optionsHtml = hasOptions
          ? options
              .map((option, i) => {
                const ordered = option.values
                  .map((value, j) => ({ value, j }))
                  .sort((a, b) => {
                    const rank = (x) => (x.value === current.options[i] ? 0 : valueAvailable(i, x.value) ? 1 : 2);
                    return rank(a) - rank(b) || a.j - b.j;
                  });
                const pills = ordered
                  .map(({ value, j }) => {
                    const id = `${uid}-o${i}-${j}`;
                    return (
                      `<input type="radio" class="byon-qa__radio visually-hidden" id="${id}" name="${uid}-o${i}"` +
                      ` value="${byonEsc(value)}" data-qa-option="${i}"${value === current.options[i] ? ' checked' : ''}>` +
                      `<label class="byon-pill" for="${id}"><span class="byon-pill__text">${byonEsc(value)}</span>` +
                      `<span class="byon-pill__note" hidden>&nbsp;· Agotado</span></label>`
                    );
                  })
                  .join('');
                return (
                  `<fieldset class="byon-qa__option"><legend class="byon-qa__legend">${byonEsc(option.name)}: ` +
                  `<span data-qa-legend="${i}">${byonEsc(current.options[i])}</span></legend>` +
                  `<div class="byon-qa__pills">${pills}</div></fieldset>`
                );
              })
              .join('')
          : '';

        const cartAdd = (window.routes && window.routes.cart_add_url) || '/cart/add';

        this.modalContent.innerHTML = `
          <div class="byon-qa" data-byon-qa data-byon-item="${product.id}" data-byon-name="${byonEsc(product.title)}">
            <div class="byon-qa__scroll">
              <div class="byon-qa__head">
                <img class="byon-qa__thumb" data-qa-thumb src="" width="64" height="64" alt="">
                <div class="byon-qa__info">
                  ${product.vendor ? `<p class="byon-qa__vendor">${byonEsc(product.vendor)}</p>` : ''}
                  <h2 class="byon-qa__title" id="${uid}-title">${byonEsc(product.title)}</h2>
                  <p class="byon-qa__price" data-qa-price></p>
                  <p class="byon-qa__cuotas" data-qa-cuotas></p>
                </div>
              </div>
              ${optionsHtml}
              <div class="byon-qa__qty-row">
                <span class="byon-qa__label" id="${uid}-qty-label">Cantidad</span>
                <div class="byon-qa__qty">
                  <button type="button" class="byon-qa__qty-btn" data-qa-step="-1" aria-label="Quitar una unidad">&minus;</button>
                  <input type="number" class="byon-qa__qty-input" data-qa-qty value="1" min="1" step="1" inputmode="numeric" aria-labelledby="${uid}-qty-label">
                  <button type="button" class="byon-qa__qty-btn" data-qa-step="1" aria-label="Agregar una unidad">+</button>
                </div>
              </div>
            </div>
            <div class="byon-qa__footer">
              <product-form class="byon-qa__form">
                <form method="post" action="${byonEsc(cartAdd)}" accept-charset="UTF-8" enctype="multipart/form-data" novalidate class="form" id="${uid}-form">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="id" value="${current.id}">
                  <input type="hidden" name="quantity" value="1" data-qa-qty-field>
                  <div class="product-form__error-message-wrapper byon-qa__error" role="alert" hidden>
                    <span class="product-form__error-message"></span>
                  </div>
                  <button type="submit" name="add" class="byon-qa__submit" aria-haspopup="dialog">
                    <span data-qa-submit-label>Agregar al carro</span>
                    <div class="loading-overlay__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>
                    </div>
                  </button>
                </form>
              </product-form>
              <a class="byon-qa__details" data-qa-details href="${byonEsc(product.url)}">Ver detalle del producto</a>
            </div>
          </div>`;

        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) dialog.setAttribute('aria-labelledby', `${uid}-title`);

        this.modalContent.querySelectorAll('[data-qa-option]').forEach((radio) => {
          radio.addEventListener('change', () => this.onOptionChange(Number(radio.dataset.qaOption), radio.value));
        });
        this.modalContent.querySelectorAll('[data-qa-step]').forEach((button) => {
          button.addEventListener('click', () => this.setQty(this.qa.qty + Number(button.dataset.qaStep) * this.getStep()));
        });
        const qtyInput = this.modalContent.querySelector('[data-qa-qty]');
        if (qtyInput) qtyInput.addEventListener('change', () => this.setQty(parseInt(qtyInput.value, 10)));

        this.updateAvailability();
        this.updateVariant();
      }

      getRule() {
        const rule = (this.qa && this.qa.current && this.qa.current.quantity_rule) || {};
        return { min: Math.max(1, Number(rule.min) || 1), max: rule.max ? Number(rule.max) : null, step: Math.max(1, Number(rule.increment) || 1) };
      }

      getStep() {
        return this.getRule().step;
      }

      setQty(value) {
        if (!this.qa) return;
        const rule = this.getRule();
        let qty = Number.isFinite(value) ? value : rule.min;
        if (qty < rule.min) qty = rule.min;
        if (rule.max && qty > rule.max) qty = rule.max;
        this.qa.qty = qty;
        this.updateVariant();
      }

      onOptionChange(index, value) {
        const qa = this.qa;
        if (!qa) return;
        qa.selected[index] = value;
        let match = qa.variants.find((variant) => variant.options.every((opt, i) => opt === qa.selected[i]));
        if (!match || !match.available) {
          const fallback = qa.variants.find((variant) => variant.available && variant.options[index] === value);
          if (fallback) {
            qa.selected = fallback.options.slice();
            match = fallback;
          }
        }
        if (match) qa.current = match;
        this.modalContent.querySelectorAll('[data-qa-option]').forEach((radio) => {
          radio.checked = qa.selected[Number(radio.dataset.qaOption)] === radio.value;
        });
        this.updateAvailability();
        this.setQty(qa.qty);
      }

      updateAvailability() {
        const qa = this.qa;
        this.modalContent.querySelectorAll('[data-qa-option]').forEach((radio) => {
          const index = Number(radio.dataset.qaOption);
          const available = qa.variants.some((variant) => variant.available && variant.options[index] === radio.value);
          radio.disabled = !available && !radio.checked;
          const label = radio.nextElementSibling;
          if (label) {
            label.classList.toggle('is-soldout', !available);
            const note = label.querySelector('.byon-pill__note');
            if (note) note.hidden = available;
          }
        });
      }

      updateVariant() {
        const qa = this.qa;
        if (!qa) return;
        const { product, current } = qa;
        const root = this.modalContent;

        const idInput = root.querySelector('input[name="id"]');
        if (idInput) idInput.value = current.id;
        const qtyField = root.querySelector('[data-qa-qty-field]');
        if (qtyField) qtyField.value = qa.qty;
        const qtyInput = root.querySelector('[data-qa-qty]');
        if (qtyInput) {
          const rule = this.getRule();
          qtyInput.value = qa.qty;
          qtyInput.min = rule.min;
          qtyInput.step = rule.step;
          if (rule.max) qtyInput.max = rule.max;
          else qtyInput.removeAttribute('max');
        }

        qa.selected.forEach((value, i) => {
          const legend = root.querySelector(`[data-qa-legend="${i}"]`);
          if (legend) legend.textContent = value;
        });

        const priceEl = root.querySelector('[data-qa-price]');
        const pack = this.pack || {};
        if (priceEl) {
          const compare = Number(current.compare_at_price) || 0;
          let html = `<span class="byon-qa__price-now">${byonMoney(current.price)}</span>`;
          if (pack.isPack && pack.ref > (Number(current.price) || 0)) {
            // R4 (8-oct-2026, regla de Pablo del 7-oct): el pack muestra su tachado como la tarjeta y la ficha.
            html +=
              `<s class="byon-qa__price-was"><span class="visually-hidden">Precio normal: </span>${byonMoney(pack.ref)}</s>` +
              `<span class="byon-qa__save">Ahorras ${byonMoney(pack.ref - current.price)}</span>`;
          } else if (pack.isPack) {
            // K4: sin tachado ni "−%"; solo el ahorro real frente a comprar por separado, si hay datos.
            // X (por separado) viene de la tarjeta (byon-pack-savings); Y se recalcula con el precio de la variante elegida.
            const packSaving = pack.separate > 0 ? pack.separate - (Number(current.price) || 0) : 0;
            if (pack.separate > 0 && pack.saving > 0 && packSaving > 0) {
              html += `<span class="byon-qa__pack">Por separado ${byonMoney(pack.separate)} · Ahorras ${byonMoney(packSaving)}</span>`;
            }
          } else if (compare > current.price) {
            html +=
              `<s class="byon-qa__price-was"><span class="visually-hidden">Precio normal: </span>${byonMoney(compare)}</s>` +
              `<span class="byon-qa__save">Ahorras ${byonMoney(compare - current.price)}</span>`;
          }
          priceEl.innerHTML = html;
        }
        const cuotasEl = root.querySelector('[data-qa-cuotas]');
        if (cuotasEl) {
          const byonCart = window.byonCart;
          const pay = byonCart && typeof byonCart.payText === 'function' ? byonCart.payText(current.price, 'qa', current.available) : null;
          if (pay !== null && pay !== undefined) {
            cuotasEl.textContent = pay;
            cuotasEl.hidden = !pay;
          } else {
            const cuota = byonCuota(current.price);
            cuotasEl.textContent = current.available && cuota > 0 ? `3 cuotas de ${byonMoney(cuota)} sin interés con débito` : '';
            cuotasEl.hidden = !(current.available && cuota > 0);
          }
        }
        const qaRoot = root.querySelector('[data-byon-qa]');
        if (qaRoot) qaRoot.setAttribute('data-byon-price', String(Math.round((Number(current.price) || 0) / 100)));

        const thumb = root.querySelector('[data-qa-thumb]');
        if (thumb) {
          const src = (current.featured_image && current.featured_image.src) || product.featured_image;
          const next = byonImg(src, 160);
          if (next && thumb.getAttribute('src') !== next) thumb.setAttribute('src', next);
        }

        const details = root.querySelector('[data-qa-details]');
        if (details) details.setAttribute('href', `${product.url}?variant=${current.id}`);

        const submit = root.querySelector('.byon-qa__submit');
        const label = root.querySelector('[data-qa-submit-label]');
        if (submit && label) {
          if (current.available) {
            submit.disabled = false;
            submit.removeAttribute('aria-disabled');
            label.textContent = `Agregar al carro · ${byonMoney(current.price * qa.qty)}`;
          } else {
            submit.disabled = true;
            submit.setAttribute('aria-disabled', 'true');
            label.textContent = 'Agotado';
          }
        }
      }
    }
  );
}